"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InlineBanner;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _index2 = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _image = require("@site/pattern-library-core/image");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _boxModelSize = require("@site/pattern-library-utils/box-model-size");
var _intents = _interopRequireWildcard(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _auctionWidget = _interopRequireDefault(require("./auction-widget.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

const BannerPicture = /*#__PURE__*/(0, _react2.styled)(_image.LazyPicture)({
  name: "BannerPicture",
  class: "pl-b1t07h6k"
});
const BannerCtas = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BannerCtas",
  class: "pl-b1a3oj0q"
});
const InlineBannerSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "InlineBannerSection",
  class: "pl-i16hi0nt",
  vars: {
    "i16hi0nt-2": [({
      alignment
    }) => alignment],
    "i16hi0nt-3": [({
      alignment
    }) => alignment === 'space-between' ? '1 1 auto' : '0 1 auto']
  }
});

/**
 * Inline Banner Component
 * @module InlineBanner
 *
 * @param {Object} props React props
 * @param {string} props.id The component's id
 * @param {string} props._name The component's tracking name
 * @param {Object} props.image Banner Image data
 * @param {Object} props.eyebrow Eyebrow text
 * @param {Object} props.heading Heading text
 * @param {string} props.description Description text
 * @param {boolean} props.disclaimer Disclaimer Text
 * @param {Array} props.ctas Headline call to action buttons
 * @param {string} props.layout Banner layout type
 * @param {String} props.verticalMargin Vertical Outer Spacing
 * @param {String} props.verticalPadding Vertical Inner Spacing
 * @param {String} props.auctionTitle Auction Iframe title
 * @param {String} props.auctionIsc Auction Isc Parameter value
 * @param {string} props.partial Partial
 * @returns {React.ReactElement} Inline Banner Component
 * @public
 */
function InlineBanner({
  id,
  _name,
  invert = false,
  image,
  backgroundColor,
  headlineLockup,
  ctas,
  layout = 'space-between',
  dataCy = 'inline-banner',
  verticalMargin = 'small',
  verticalPadding = 'small',
  auctionTitle,
  auctionIsc,
  auctionErrorPageContent,
  auctionOverwriteUrl,
  partial,
  ...headlineProps
}) {
  const {
    url,
    altText,
    width,
    height
  } = image ?? {};
  return /*#__PURE__*/_react.default.createElement(InlineBannerSection, {
    dataCy: dataCy,
    _name: _name,
    partial: partial || (invert ? 'dark1' : ''),
    backgroundColor: partial ? _intents.default.ux.box.backgroundColor : (0, _intents.getBackgroundColor)(backgroundColor),
    alignment: layout,
    textAlign: "center",
    verticalMargin: verticalMargin,
    verticalPadding: verticalPadding
  }, image && /*#__PURE__*/_react.default.createElement(BannerPicture, {
    defaultSrc: url,
    defaultAltText: altText,
    width: width > 0 ? width : 'auto',
    height: height > 0 ? height : 'auto',
    loading: "lazy"
  }), headlineLockup ? headlineLockup : (headlineProps.heading || headlineProps.description) && /*#__PURE__*/_react.default.createElement(_index.default, headlineProps), ctas && /*#__PURE__*/_react.default.createElement(BannerCtas, {
    "data-cy": "banner-actions"
  }, /*#__PURE__*/_react.default.createElement(_index2.default, {
    actionsLayout: "button-set",
    ctas: ctas
  })), auctionTitle && /*#__PURE__*/_react.default.createElement(_auctionWidget.default, {
    id,
    _name,
    title: auctionTitle,
    isc: auctionIsc,
    errorPageContent: auctionErrorPageContent,
    overwriteUrl: auctionOverwriteUrl
  }));
}
InlineBanner.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  invert: _propTypes.default.bool,
  image: _propTypes.default.shape(_image.LazyPicture.propTypes),
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  headlineLockup: _propTypes.default.node,
  ctas: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array]),
  layout: _propTypes.default.oneOf(['space-between', 'center']),
  auctionTitle: _propTypes.default.string,
  auctionIsc: _propTypes.default.string,
  ..._boxModelSize.marginProps,
  ..._boxModelSize.paddingProps,
  ..._index.default.propTypes,
  partial: _propTypes.default.string
};